import React from "react";
import DatePickerField from "controls/global/datepicker";
// import { isValidDate } from "pages/file/utils/helper";
// import useFormWrapper from "utils/custom-hooks/useFormWrapper";

type Props = {
  name: string;
  defaultValue?: any;
  disabled?: boolean;
  onChange?: (date: Date | null) => void;
  // forceRerender: boolean;
};

export default function TitleExaminedToDateField  ({
  name,
  defaultValue,
  disabled,
  onChange,
  // forceRerender,
}: Props)  {

  // const {setValue} =  useFormWrapper();

  const onChangeCallback = (date: Date | null) => {
    // if (!isValidDate(date)) {
    //   setTimeout(() => {
    //     setValue(name, undefined);  
    //   }, 100);
    // }
    onChange && onChange(date);
  };

  return (
    <>
      <DatePickerField
        label="Title Examined To"
        // minDate={new Date()}
        showError={true}
        validateOnBlur={false}
        {...{
          disabled,
          name,
          defaultValue,
          onChangeCallback: onChangeCallback,
          onBlurCallback: onChangeCallback,
        }}
      />
    </>
  );
}
